export const seedCategories = [
  {
    "id": "main_cat_1770964469516645",
    "name": "티켓/입장권",
    "createdAt": "2026-02-13T06:34:29.516Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517930",
    "name": "테마파크",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517156",
    "name": "교통/패스",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517357",
    "name": "지하철/시티패스",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517266",
    "name": "공항열차/특급",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517917",
    "name": "전망대",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517240",
    "name": "수족관/동물원",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_177096446951724",
    "name": "온천/스파",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517211",
    "name": "뮤지엄/전시",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517446",
    "name": "버스/이동",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517391",
    "name": "공항 리무진",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517213",
    "name": "케이블카",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517931",
    "name": "투어/액티비티",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  },
  {
    "id": "main_cat_1770964469517989",
    "name": "투어/체험",
    "createdAt": "2026-02-13T06:34:29.517Z",
    "updatedAt": "2026-02-13T06:34:29.517Z"
  }
];
